




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import KriteriaIcuKeluarSection from "@/components/kriteria-icu/KriteriaIcuKeluarSection.vue";
import KriteriaIcuMasukSection from "@/components/kriteria-icu/KriteriaIcuMasukSection.vue";
import KriteriaIcuSvc from "@/services/KriteriaIcuService";
import { appModule } from "@/store/modules/app";
import { storeKriteriaIcu } from "@/store/modules/KriteriaIcuStore";
import { userModule } from "@/store/modules/user";

@Component({
	components: {
		KriteriaIcuMasukSection,
		KriteriaIcuKeluarSection,
	},
	inject: {
		isReadOnly: { default: () => () => false },
	},
})
export default class KriteriaIcuPage extends Vue {
	@Prop() register!: string | number;
	@Prop() rm!: string | number;
	@Prop({ default: false }) isActive!: boolean;
	//  "all" = tampilkan semua step; "masuk"/"keluar" untuk split tab di IcuHcuPage
	@Prop({ default: "all" }) phase!: "masuk" | "keluar" | "all";
	isReadOnly!: () => boolean;

	get readOnly(): boolean {
		return this.isReadOnly();
	}

	step = 1;
	deleteDialog = false;
	deleting = false;
	loaded = false;

	get kriteriaIcu() {
		return storeKriteriaIcu.currentItem;
	}

	get loading() {
		return storeKriteriaIcu.loading;
	}

	get isCreator(): boolean {
		const rec: any = this.kriteriaIcu;
		return !!rec && !!rec.created_by && Number(rec.created_by) === Number(userModule.user.id);
	}

	get canDelete(): boolean {
		const rec: any = this.kriteriaIcu;
		if (!rec || !rec.id || this.readOnly) {
			return false;
		}
		return !rec.masuk_signed_at || this.isCreator;
	}

	@Watch("isActive", { immediate: true })
	onActiveChange(val: boolean) {
		if (val && !this.loaded) {
			this.fetchData();
			this.loaded = true;
		}
	}

	async fetchData() {
		await storeKriteriaIcu.getByRegister(this.register);
		if (this.phase === "keluar") {
			this.step = 2;
		}
	}

	async onSaved(nextStep: number, data: any) {
		if (data?.id) {
			await storeKriteriaIcu.refresh(data.id);
		}
		this.step = nextStep;
	}

	printPdfMasuk() {
		if (this.kriteriaIcu?.id) {
			KriteriaIcuSvc.printPdfMasuk(this.kriteriaIcu.id);
		}
	}

	printPdfKeluar() {
		if (this.kriteriaIcu?.id) {
			KriteriaIcuSvc.printPdfKeluar(this.kriteriaIcu.id);
		}
	}

	confirmDelete() {
		this.deleteDialog = true;
	}

	async doDelete() {
		this.deleting = true;
		try {
			const resp = await KriteriaIcuSvc.destroy(this.kriteriaIcu.id);
			if (resp?.data?.status === "1") {
				appModule.NoticeDelay("Berhasil menghapus kriteria ICU");
				storeKriteriaIcu.reset();
				this.deleteDialog = false;
				this.step = 1;
			}
		} catch (e) {
			// handled by service
		}
		this.deleting = false;
	}

	beforeDestroy() {
		storeKriteriaIcu.reset();
	}
}
